// Note: The first file of a module here, must also register the module

import "./consent-type-settings.component";
import "./create-consent-type.component";
